<template lang="pug">
.container
  el-header
    h4 {{$t('Unknown UUIDs')}}
    hr.header
  table(width="100%", v-if='unknownUUIDs.length > 0')
    tr.header-row
      th
        p {{ $t('UUID') }}&nbsp;
          el-input.el-input(id="SearchByUUID-searchInput" v-model='params.uuid', type="text", name="uuid", ref="uuid", style="width: 30%;", :placeholder="$t('UUID')", @input='handleInputChange()', size='mini')
      th
        p {{ $t('Created') }}
      th
        p {{ $t('Action') }}
    tr.desktop-row(v-for='unknownUUID in unknownUUIDs', :key='unknownUUID.id', :id="'unknownUUID'+unknownUUID.id")
      td
        p.selectable {{ unknownUUID.uuid }}
      td
        p {{ humanTime(unknownUUID.updatedAt) }}
      td
        .buttons
          el-button-group
            el-button(
              :id="'SearchByUUID-assignUUID-button'+unknownUUID.id",
              type='success',
              size='mini',
              :title="$t('Assign UUID to existing screen')",
              @click="openScreenSelector(unknownUUID)"
            )
              font-awesome-icon(icon="exchange-alt")
            el-button(
              :id="'SearchByUUID-deleteUUID-button'+unknownUUID.id",
              type='success',
              size='mini',
              :title="$t('Delete unknown UUID')",
              @click="deleteUUID(unknownUUID)"
            )
              font-awesome-icon(icon="trash")
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='screenSelectorVisible', @close='closeScreenSelector()', append-to-body, width='60%')
    .title
      h4 {{ $t('Choose screen to copy UUID')}} '{{ selectedUnknownUUID.uuid }}'
      el-button.save-button(:disabled='!selectedDesktop.id', type='success', size='mini', @click='assignUUID()')
        span {{ $t('Assign UUID') }} &nbsp;
        font-awesome-icon(icon="exchange-alt")
    hr.header
    .row
      .thumb-container
      .cell.name {{ $t('Screen name') }}&nbsp;
        el-input.el-input(id="SearchDesktopByName-searchInput" v-model='desktopNameSearch', type="text", style="width: 60%;", size='mini')
      .cell.uuid {{ $t('UUID') }}&nbsp;
        el-input.el-input(id="SearchDesktopByName-searchInput" v-model='desktopUUIDSearch', type="text", style="width: 60%;", size='mini')
      .cell.HBTimestamp {{ $t('Last contact') }}
      .cell.tick
    .row(v-if='desktopsFiltered().length === 0')
      p.warning {{ $t('No screen found. Please, refine your search.')}}
    .row(
      v-for="desktop in desktopsFiltered()",
      :class='{ inactive: desktop.HBTimestamp === 0, dead: !desktop.alive,  selected: desktop.id === selectedDesktop.id }',
      @click='selectDesktop(desktop)'
    )
      .thumb-container
        img.thumbnail(v-if='getScreenShotURI(desktop).length > 0', :src='getScreenShotURI(desktop)')
      .cell.name {{ getFullDeviceNameByDesktopId(desktop.id) }}
      .cell.uuid {{ desktop.uuid }}
      .cell.HBTimestamp {{ desktop.HBTimestamp > 0 ?  humanTime(desktop.HBTimestamp) : '-' }}
      .cell.tick
        font-awesome-icon(v-if='desktop.id === selectedDesktop.id', icon="check")
  ConfirmDialog(
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied'
  )
  p.error(v-if='errors.length > 0')
    pre {{ errors }}
</template>

<script>
import Vue from 'vue'
import testUtils from './../Common/textUtils.mixin'
import deviceUtils from './../Common/deviceUtils.mixin'
import NetworkSelector from './../Common/NetworkSelector'
import ConfirmDialog from '../Common/ConfirmDialog'
import List from './List'

export default {
  mixins: [testUtils, deviceUtils],
  props: [],
  components: {
    NetworkSelector,
    ConfirmDialog,
    List
  },
  async created () {
    await this.loadData()
  },
  data () {
    return {
      errors: [],
      params: {
        uuid: undefined
      },
      desktopNameSearch: '',
      desktopUUIDSearch: '',
      unknownUUIDs: [],
      screenSelectorVisible: false,
      confirmDialogQuestion: null,
      confirmDialogVisible: false,
      rightClickData: {},
      selectedDesktop: {},
      selectedUnknownUUID: {}
    }
  },
  methods: {
    isSelected (desktop) {
      return this.selectedDesktop.id === desktop.id
    },
    selectDesktop (desktop) {
      this.selectedDesktop = desktop
    },
    async loadData () {
      this.unknownUUIDs = (await Vue.axios.get('/uuidunknown')).data
    },
    async deleteUUID (uuid) {
      this.unknownUUIDs = (await Vue.axios.delete('/uuidunknown/' + uuid.id)).data
      await this.loadData()
    },
    openScreenSelector (uuid) {
      this.selectedUnknownUUID = uuid
      this.screenSelectorVisible = true
    },
    closeScreenSelector () {
      this.selectedDesktop = {}
      this.screenSelectorVisible = false
    },
    async dialogDenied (data) {
      return data
    },
    async dialogConfirmed (payload) {
      return payload
    },
    async assignUUID () {
      // 1. Update desktop uuid and reset secret.
      // Reseting secret, triggers delete unknownUUID, while updating secret by device.
      // Makes processing of newly added devices by service unchanged - first device, update uuid afterwards.
      await Vue.axios.patch('/devicedesktop/' + this.selectedDesktop.id, {
        uuid: this.selectedUnknownUUID.uuid,
        secret: null
      })
      // 2. delete unknown uuid
      await this.deleteUUID(this.selectedUnknownUUID)
      this.closeScreenSelector()
      this.loadData()
    },
    async handleInputChange () {
      if (this.params.uuid.length < 1) return false
      await this.__search()
    },
    async __search () {
      return []
    },
    desktopsFiltered () {
      let result = this.$store.state.Device.desktop_list
      if (this.desktopNameSearch.length > 0) {
        const devices = this.$store.state.Device.device_list
          .filter(dd => dd.name.toLowerCase().indexOf(this.desktopNameSearch.toLowerCase()) > -1)
          .map(dd => dd.id)
        // 1.1 desktops
        const desktopsOfDevicesNames = this.$store.state.Device.desktop_list.filter(d => devices.includes(d.Device))
          .map(d => d.id)
        const desktopsNames = this.$store.state.Device.desktop_list
          .filter(d => d.name.toLowerCase().indexOf(this.desktopNameSearch.toLowerCase()) > -1)
          .map(d => d.id)
        const desktopIdsNames = [...new Set([...desktopsOfDevicesNames, ...desktopsNames])]
        result = this.$store.state.Device.desktop_list.filter(d => desktopIdsNames.includes(d.id))
        if (this.desktopUUIDSearch.length === 0) return result
      }
      if (this.desktopUUIDSearch.length > 0) {
        return result
          .filter(d => d.uuid)
          .filter(d => d.uuid.toLowerCase().indexOf(this.desktopUUIDSearch.toLowerCase()) > -1)
      }
      return result
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.error {
  color: $--color-warning;
}
.save-button {
  margin: 10px 0px;
}
.title {
  display: flex;
  .save-button {
    margin-left: auto;
  }
}
.row {
  padding: 10px 10px;
  border-bottom:  $--border-light;
  cursor: pointer;
  color: $--color-text-primary;
  font-size: $--font-size-base;
  display: flex;
  align-items: center;
  &.dead {
    background-color: rgba(mix($--background-color-selected, $--color-danger, 94%), 0.6);
  }
  &.inactive {
    background-color: rgba(mix($--background-color-selected, $--color-success, 94%), 0.6);
  }
  &.selected {
    font-weight: bold;
    color: $--color-text-primary;
    background-color:  $--background-color-selected;
  }
  &.selected.dead {
    font-weight: bold;
    color: $--color-text-primary;
    background-color:  rgba(mix($--background-color-selected, $--color-danger, 94%), 0.4);
  }
  &.selected.inactive {
    font-weight: bold;
    color: $--color-text-primary;
    background-color:  rgba(mix($--background-color-selected, $--color-success, 94%), 0.4);
  }
  .thumb-container {
    width: 10%;
    .thumbnail {
      max-width: 30px;
      max-height: 30px;
    }
  }
  .name {
    width: 30%;
  }
  .uuid {
    width: 30%;
  }
  .HBTimestamp {
    width: 30%;
  }
}
table {
  padding: 0px;
  border-spacing: 0px;
  th, td {
    text-align: left;
    width: 20%;
  }
  .desktop-row {
    td {
      border-bottom: $--border-light;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/UnknownUUIDs.vue